<template>
    <PriorApproval :ServiceID="AppServiceID"></PriorApproval>
</template>
<script>
import PriorApproval from '@/components/Common/PriorApproval.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
        AppServiceID:''
        }
    },
 components: {
    PriorApproval  : PriorApproval 
        },
   created: function() {
      this.$emit('update:layout', LayoutDefault);
      this.AppServiceID = this.$store.getters.GetPodiatryID;
    },
    beforeCreate: function() { 
        this.$store.dispatch('AddServiceID',this.$store.getters.GetPodiatryID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetPodiatryID); 
    },
}
</script>
